<template>
  <v-dialog v-model="dialogIsVisible" max-width="400">
    <h3 class="text-subtitle-1 mb-10"><b>Redigera kurs</b></h3>
    
    <v-form
      ref="form"
      :lazy-validation="true"
      @submit.prevent="onSave()"
      v-if="courseData"
    >
      <v-text-field
        outlined
        v-model="courseData.courseName"
        label="Kursnamn"
        :rules="[rules.required]"
      />

      <v-text-field
        outlined
        v-model="courseData.courseCode"
        label="Kurskod"
        :rules="[rules.required]"
      />

      <v-text-field
        outlined
        v-model="courseData.credit"
        label="Poäng"
        :rules="[rules.required]"
      />

      <v-text-field
        outlined
        v-model="courseData.alias"
        label="Alias"
      />

      <div class="d-flex justify-end mt-10">
        <v-btn outlined @click="$emit('close')">
          <v-icon small>$sl-close</v-icon>
          Avbryt
        </v-btn>

        <v-btn class="ml-4" type="submit">
          <v-icon small>$sl-save</v-icon>
          Spara
        </v-btn>
      </div>
    </v-form>
  </v-dialog>
</template>

<script>
import get from 'lodash/get'
import {RulesMixin} from '@/components/mixins'
import API from '@/services/api'

export default {
    name: 'TheEditCourseDialog',

    mixins: [RulesMixin],

    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      course: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      courseData: {}
    }),

    computed: {
      dialogIsVisible: {
        get() {
          return this.isVisible
        },
        set() {
          this.$emit('close')
        }
      }
    },

    watch: {
      course: {
        handler(value) {
          this.courseData = { ...this.courseData, ...JSON.parse(JSON.stringify(value)) }
        }
      }
    },

    methods: {
      get,

      async onSave() {
        try {
          if (!this.$refs.form.validate())
            return this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')

          const courseId = get(this, 'courseData.id', 0)

          await API.updateCourse(courseId, { data: this.courseData })
          this.$emit('close')
          this.$emit('on-save', this.courseData)
          this.$events.fire('showInfo', 'Sparat.')
        } catch (error) {
          this.$events.fire('showError', 'Det har uppstått ett problem. Var god försök igen.')
        }
      }
    }
  };
</script>

<style>

</style>